import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import SkillsTab from './SkillsTab';
import Row from 'react-bootstrap/Row';
import { Jumbotron } from './migration';
import { Container } from 'react-bootstrap';
import { useScrollPosition } from '../../hooks/useScrollPosition';
import { motion } from 'framer-motion';

const Skills = React.forwardRef(({ heading, hardSkills, softSkills }, ref) => {
  const skillsTabRef = React.useRef(null);
  const [isScrolled, setIsScrolled] = React.useState(false);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (!isScrolled && currPos.y - 400 < 0) setIsScrolled(true);
    },
    [],
    skillsTabRef
  );
  
  return (
    <Jumbotron ref={skillsTabRef} fluid className="proficiency m-0" id="proficiency">
      <Container className="p-5">
        <motion.h2
          ref={skillsTabRef}
          className="display-4 pb-5 text-center"
          initial={{ opacity: 0, y: -24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45 }}
          style={{ fontWeight: 700, color: 'var(--text-primary)' }}
        >
          {heading}
        </motion.h2>
        <Tabs 
          className="skills-tabs" 
          defaultActiveKey="hard-skills" 
          id="skills-tabs" 
          fill
        >
          <Tab 
            tabClassName="skills-tab" 
            eventKey="hard-skills" 
            title="Technical"
            style={{ fontWeight: 600 }}
          >
            <Row className="pt-3 px-1">
              <SkillsTab skills={hardSkills} isScrolled={isScrolled} />
            </Row>
          </Tab>
          <Tab 
            tabClassName="skills-tab" 
            eventKey="soft-skills" 
            title="Interpersonal"
            style={{ fontWeight: 600 }}
          >
            <Row className="pt-3 px-1">
              <SkillsTab skills={softSkills} isScrolled={isScrolled} />
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </Jumbotron>
  );
});

export default Skills;
